module.exports = __webpack_public_path__ + "static/img/index.e26c167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.png
// module id = zICw
// module chunks = 3